import React, { useContext, useEffect, useState } from "react"
import { useHistory, useLocation } from "react-router-dom"
import { NavbarLogo, NavbarMenuToggle, NavbarRightSection, NavbarIconContainer, FontAwesomeIcon, Button, NotificationHub } from "@nef/core"
import { useDispatch } from "react-redux"

import displayRouteName from "../../services/displayRouteName"
import StyledAppNavBar from "../../styles/_NavBar.styles"
import useAuthContext from "../../hooks/useAuthContext"
import InstrumentSearch from "../../components/common/InstrumentSearch"
import { AppDispatch } from "../../app/store"
import { fetchInstrumentObjectById, setSelectedInstrument } from "../../redux/instrument/actions"
import { MODAL_ACCESS_TYPES } from "../../types/_enums"
import SystemStatus from "../../components/common/SystemStatus"
import AuthContext from "../../contexts/AuthContext"

import AppHeader from "./_Header"


const AppNavBar = (props: any) => {
  const { sidebar, setSidebar, display, setDisplay, hideSidebar, setHideSidebar } = props

  const { accessToken, setAccessToken } = useAuthContext()
  const history = useHistory()
  const location = useLocation()
  const [headerName, setHeaderName] = useState<string>("")
  const dispatch = useDispatch<AppDispatch>()
  const {handleLogOutUser} = useContext(AuthContext)

  // * handler for the instrument select from search
  const onInstrumentSelect = async ({ row: { original: {id} } }: any) => {
    try {
      const res = await dispatch(fetchInstrumentObjectById(id)).unwrap()
      await dispatch(setSelectedInstrument(res))
      history.push(`/instrument_summary?instrumentMode=${MODAL_ACCESS_TYPES.VIEW}&nsm=${res?.nsm}&&appId=${id}`)
    } catch (error: any) {
      NotificationHub.send("danger", `${error.status} ${error.message}`)
    }
  }

  useEffect(() => {
    setHeaderName(displayRouteName(location.pathname.split("/")[1]))
  }, [location])

  return (
    <>
      <StyledAppNavBar
        doHideOnScroll={true}
        style={{
          position: "unset",
          padding: "10px 0px"
        }}
      >
        {accessToken ? (
          <>
            <NavbarIconContainer
              onClick={() => {
                setDisplay("none")
                setSidebar(!sidebar)
                // show hide sidebar
                if (hideSidebar === "-100%") {
                  setHideSidebar("0")
                } else {
                  setHideSidebar("-100%")
                }
              }}
            >
              <Button className="admin-btn" style={{ marginLeft: "1em" }} size="md" color="link" isLoading={false} onClick={() => handleLogOutUser()}>
                <FontAwesomeIcon iconClassName="fa-lock" style={{ paddingRight: "10px" }} />
                LOGOUT
              </Button>
            </NavbarIconContainer>
            <div className="gInstrument__container">
              <InstrumentSearch onInstrumentSelect={onInstrumentSelect} showBackdrop={true} bodyHeight={300} />
            </div>
            <SystemStatus />
          </>
        ) : (
          <NavbarIconContainer
            onClick={() => {
              if (display === "none" && sidebar === false) {
                setDisplay("block")
                setSidebar(true)
              } else {
                setDisplay("none")
                setSidebar(false)
              }
              // show hide sidebar
              if (hideSidebar === "-100%") {
                setHideSidebar("0")
              } else {
                setHideSidebar("-100%")
              }
            }}
          >
            <Button
              className="login-btn"
              style={{ marginLeft: "1em" }}
              size="md"
              color="link"
              isLoading={false}
            >
              <FontAwesomeIcon iconClassName="fa-unlock" style={{ paddingRight: "10px" }} /> Login
            </Button>
          </NavbarIconContainer>
        )}
        <NavbarRightSection className="navbar-right-section" style={{ marginRight: "1em" }}>
          <NavbarLogo as="a" href="/" />
        </NavbarRightSection>
        <NavbarMenuToggle isOpen={true} />
      </StyledAppNavBar>
      <AppHeader>{headerName}</AppHeader>
    </>
  )
}

export default AppNavBar
